import { render, staticRenderFns } from "./Project17.vue?vue&type=template&id=fafe537c&scoped=true&"
import script from "./Project17.vue?vue&type=script&lang=js&"
export * from "./Project17.vue?vue&type=script&lang=js&"
import style0 from "./Project17.vue?vue&type=style&index=0&id=fafe537c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fafe537c",
  null
  
)

export default component.exports